import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const groups = [
  {
    title: 'Backend',
    icon: 'ri-server-line',
    color: 'text-primary-400',
    techs: ['.NET', 'Node.js', 'NestJS', 'REST APIs'],
  },
  {
    title: 'Frontend',
    icon: 'ri-layout-4-line',
    color: 'text-secondary-400',
    techs: ['React', 'React Native', 'Angular'],
  },
  {
    title: 'Data',
    icon: 'ri-database-2-line',
    color: 'text-accent-400',
    techs: ['PostgreSQL', 'MySQL', 'SQL Server', 'MongoDB', 'SAP HANA'],
  },
  {
    title: 'Enterprise',
    icon: 'ri-building-2-line',
    color: 'text-primary-400',
    techs: ['SAP Business One', 'Service Layer', 'DI API'],
  },
  {
    title: 'Infrastructure',
    icon: 'ri-cloud-line',
    color: 'text-secondary-400',
    techs: ['Docker', 'Cloud', 'Linux', 'VPS'],
  },
  {
    title: 'AI',
    icon: 'ri-brain-line',
    color: 'text-accent-400',
    techs: ['LLMs', 'AI Agents', 'RAG', 'Vector Databases', 'Automation'],
  },
  {
    title: 'Payments',
    icon: 'ri-bank-card-line',
    color: 'text-primary-400',
    techs: ['Transbank', 'Mercado Pago', 'Stripe'],
  },
];

export default function TechSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-900/40 border-y border-background-800/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Tecnologías"
          title="Tecnología moderna. Decisiones pragmáticas."
          subtitle="Elegimos la herramienta correcta para cada problema. No imponemos stacks, construimos sobre lo que tu negocio necesita."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {groups.map((g, i) => (
            <Reveal key={g.title} delay={i * 60}>
              <div className="h-full rounded-lg border border-background-700/60 bg-background-950/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-background-600">
                <div className="flex items-center gap-3">
                  <i className={`${g.icon} ${g.color} text-xl`}></i>
                  <h3 className="text-sm font-semibold font-heading text-foreground-950">
                    {g.title}
                  </h3>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {g.techs.map((t) => (
                    <span
                      key={t}
                      className="text-xs text-foreground-400 px-2.5 py-1.5 rounded-md bg-background-800/70 border border-background-700/50"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}